import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SecondaryNavigation from 'app/scripts/components/common/navigation/secondary-navigation';

import BlacklistedUsers from './blacklisted';
import WhitelistedUsers from './whitelisted';

class ModerationUsers extends Component {
  constructor(props) {
    super(props);
  }

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  render() {
    var { spotId, page, spot, isViewOnlyMode } = this.props;
    var component = null;

    switch (page) {
      case 'moderation-users-blacklisted':
        component = (
          <BlacklistedUsers spot={spot} spotId={spotId} isViewOnlyMode={isViewOnlyMode} />
        );
        break;
      case 'moderation-users-whitelisted':
        component = (
          <WhitelistedUsers spot={spot} spotId={spotId} isViewOnlyMode={isViewOnlyMode} />
        );
        break;
    }

    var secondaryMenuItems = [
      {
        label: 'Blocked',
        routeName: 'moderation-users-blacklisted',
        navParams: { spot_id: spotId }
      },
      {
        label: 'Allowed',
        routeName: 'moderation-users-whitelisted',
        navParams: { spot_id: spotId }
      }
    ];

    return (
      <div className="blacklisted">
        <SecondaryNavigation
          className="users-navigation"
          selected={page}
          menuItems={secondaryMenuItems}
        />
        {component}
      </div>
    );
  }
}

ModerationUsers.propTypes = {
  spotId: PropTypes.string.isRequired,
  isViewOnlyMode: PropTypes.bool
};

ModerationUsers.displayName = 'ModerationUsers';

export default ModerationUsers;
